export enum DemiseAdministratorDoc {
  grant_probate_with_last_will = 'grant_probate_with_last_will',
  letter_of_administration = 'letter_of_administration',
  no_document = 'no_document',
}
